function RelatedPost({data, Link}){
  return(
        <section className="recommended-posts mob">
          <h2 className="recommended-title">Related Posts</h2>
          <div className="recommended-grid">
            {data?.related?.map((post, index) => (
              <div className="recommended-card pointer-crusser" key={index}>
                <Link to={`/blog/${post?.action_url}`}>
                  <img src={post?.media} alt="Post 1" />
                </Link>
                <p className="relet-post-name">{post?.name}</p>
                <div className="txt_btn_recomend">
                  <p className="reletepost-mob-poston">
                    Posted on{" "}
                    {new Date(post?.created_at).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </p>
                  <Link to={`/blog/${post?.action_url}`} className="releted-readmore">
                    <u>Read More</u>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </section>
  )

}
export default RelatedPost;